import Component from '../core/Component'
import Scroll from '../services/Scroll'
import EventBus from '../core/EventBus'
import Color from 'color'

export default class Section extends Component {

    constructor(element) {
        super(element)
        this.isActive = false
    }

    prepare() {
        Scroll.on('resize', this.handleResize)
        Scroll.on('scroll', this.handleScroll)
        this.resize()

        try {
            const color = Color(window.getComputedStyle(this.element).getPropertyValue('background-color')).hsl()
            const [ hue, saturation, luminosity ] = color.color

            this.type = luminosity < 50 && color.valpha > 0 ? 'dark' : 'light'
        } catch (e) {
            this.type = 'dark'
        }

        this.render(Scroll.getScroll().y)
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
        Scroll.off('scroll', this.handleScroll)
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = ({offset}) => {
        this.render(offset.y)
    }

    resize = () => {
        this.windowHeight = window.innerHeight

        const toggleBox = document.getElementById('nav-opener').getBoundingClientRect()
        const box = this.element.getBoundingClientRect()
        const offset = Scroll.getScroll()
        const top = box.top + offset.y

        this.box = {
            top: top,
            height: box.height,
            start: top - this.windowHeight,
            threshold: top,
            stop: top + box.height,
            headerTop: top - toggleBox.top - toggleBox.height/2,
            headerBottom: top + box.height - toggleBox.top - toggleBox.height/2
        }
    }

    render(y) {

        if (y > this.box.headerTop && y < this.box.headerBottom) {
            if (!this.isActive) {
                this.isActive = true
                EventBus.emit('section:enter', {
                    type: this.type,
                    element: this.element
                })
            }
        } else {
            if (this.isActive) {
                this.isActive = false
                EventBus.emit('section:leave', {
                    type: this.type,
                    element: this.element
                })
            }
        }
    }

}